function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import { fetchData } from './RestAPILink/fetchData';
import { joinPath } from './RestAPILink/path';
import { queryToRequestOptions } from './RestAPILink/queryToRequestOptions';
import { queryToResourcePath } from './RestAPILink/queryToResourcePath';
export class RestAPILink {
  constructor(config) {
    _defineProperty(this, "config", void 0);

    _defineProperty(this, "versionedApiPath", void 0);

    _defineProperty(this, "unversionedApiPath", void 0);

    this.config = config;
    this.versionedApiPath = joinPath('api', String(config.apiVersion));
    this.unversionedApiPath = joinPath('api');
  }

  fetch(path, options) {
    return fetchData(joinPath(this.config.baseUrl, path), options);
  }

  executeResourceQuery(type, query, _ref) {
    let {
      signal
    } = _ref;
    return this.fetch(queryToResourcePath(this, query, type), queryToRequestOptions(type, query, signal));
  }

}